<template>
  <div class="homePage">
    <div v-show="gardenId==286">
      <el-carousel id="el-carousel" indicator-position="none">
        <el-carousel-item v-for="item in photoList" :key="item">
          <el-image :src=item fit="fill" width="100%"></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="projectBox" v-if="maintainsPageTotal3>0||events.length>0">
      <!-- 日历 -->
      <div class="projectCalendarList" v-if="events.length>0">
        <el-card style="height:96%">
          <full-calendar ref="calendar" :config="config" :events="events" @event-selected="eventClick"
            @day-click="dayClick" @moreClick="seeMore">
          </full-calendar>
        </el-card>
      </div>
      <!-- 工单列表 -->
      <el-card style="margin:10px;flex:1;min-width:540px;" v-if="maintainsPageTotal3>0">
        <div class="maintainsNum">
          <span @click='maintains(2,true)'>
            <label class="maintainsLab">待办工单：</label>
            <span class="maintainsTxt">{{maintainsPageTotal1}}</span>
          </span>
          <span @click='maintains(3,true)'>
            <label class="maintainsLab">完成工单：</label>
            <span class="maintainsTxt">{{maintainsPageTotal2}}</span>
          </span>
          <span @click='maintains(99,true)'>
            <label class="maintainsLab">总工单：</label>
            <span class="maintainsTxt">{{maintainsPageTotal3}}</span>
          </span>
        </div>
        <el-table
          :height="maintainsTableData.length > 0 ? require('@/config/enum').tableheight420 : require('@/config/enum').tableheight119"
          :data="maintainsTableData" class="wid100" :row-class-name="tableRowClassName">
          <!-- 序号 -->
          <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
          </el-table-column>
          <!-- 报事用户 -->
          <!-- <el-table-column :label="$t('lang.lab_paperusername')" width="150px">
            <template slot-scope="scope" v-if="scope.row.user">
              <el-tooltip placement="top" effect="light"
                v-if="scope.row.user.nickName&&scope.row.user.nickName.length> 20" :disabled="false">
                <div slot="content">
                  <span>{{ scope.row.user.nickName }}</span>
                </div>
                <div>
                  {{ scope.row.user.nickName.substring(0, 10) | valueIsNull }}
                  <span v-if="scope.row.user.nickName.length>10">...</span>
                </div>
              </el-tooltip>
              <el-tooltip placement="top" effect="light" v-else :disabled="true">
                <div>{{ scope.row.user.nickName | valueIsNull }}</div>
              </el-tooltip>
            </template>
            <template slot-scope="scope" v-else>
              <el-tooltip placement="top" effect="light" v-if="scope.row.userName&&scope.row.userName.length> 10"
                :disabled="false">
                <div slot="content">
                  <span>{{ scope.row.userName }}</span>
                </div>
                <div>
                  {{ scope.row.userName.substring(0, 10) | valueIsNull }}
                  <span v-if="scope.row.userName.length>10">...</span>
                </div>
              </el-tooltip>
              <el-tooltip placement="top" effect="light" v-else :disabled="true">
                <div>{{ scope.row.userName | valueIsNull }}</div>
              </el-tooltip>
            </template>
          </el-table-column> -->
          <!-- 小区 -->
          <el-table-column label="园区" width="200px">
            <template slot-scope="scope">
              <span>{{scope.row.garden.name}}</span>
            </template>
          </el-table-column>
          <!-- 内容 -->
          <el-table-column :label="$t('lang.lab_papercontent')" prop="content" width="200px">
            <template slot-scope="scope">
              <el-tooltip placement="top" effect="light"
                v-if="scope.row.content&&scope.row.content.length> require('@/config/enum').tableDatamaxlength10"
                :disabled="false">
                <div slot="content">
                  <span>{{ scope.row.content }}</span>
                </div>
                <div class="conctentstyle">
                  {{ scope.row.content.substring(0, require('@/config/enum').tableDatamaxlength10) | valueIsNull }}
                  <span v-if="scope.row.content.length>require('@/config/enum').tableDatamaxlength10">...</span>
                </div>
              </el-tooltip>
              <el-tooltip placement="top" effect="light" v-else :disabled="true">
                <div class="conctentstyle">{{ scope.row.content | valueIsNull }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <!-- 报事时间 -->
          <el-table-column :label="$t('lang.lab_papertime')" width="150px" prop="createTime" sortable>
            <template slot-scope="scope">
              <span v-if="scope.row.isOvertime === 1" class="red">{{scope.row.createTime | time}}</span>
              <span v-else>{{scope.row.createTime | time}}</span>
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column align="center" :label="$t('lang.lab_operation')" prop="operation" fixed="right">
            <template slot-scope="scope" align="center">
              <el-button class="operation" @click="detail(scope.row)">
                {{$t('lang.btn_detail')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
          :page-sizes="[1,7,10, 20, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :page-count="pageCount" />
      </el-card>
    </div>
    <div :class="{'projectBox1':(maintainsPageTotal3>0||events.length>0)}" :inline="true">
      <div v-for="(item,index) in collectList" :key="index" @click="jump(item.path)" class="image">
        <div class="borderin">
          <img :src="item.url_green" class="imageposi" v-if="themeColor === '#00b1c3'">
          <img :src="item.url_pink" class="imageposi" v-if="themeColor === '#ed8599'">
          <img :src="item.url_bluegreen" class="imageposi" v-if="themeColor === '#b4d049'">
          <div class="fontposi" :title="item.name">{{item.name}}</div>
        </div>
      </div>
      <!-- 快捷菜单 -->
      <div class="borderout" @click="openCollect" :inline="true">
        <img :src="addImage" class="imageadd">
        <div class="fontposi" :title="this.$i18n.t('lang.lab_addQuickEntry')">{{$t('lang.lab_addQuickEntry')}}</div>
      </div>
    </div>

    <el-dialog :visible.sync="dialogShow" :close-on-click-modal="false" center top="130px" width="600px" :title="title"
      @closed="handleDialogClosed">
      <el-scrollbar>
        <el-form class="trees">
          <el-tree ref="tree" :data="tableData" show-checkbox accordion node-key="id" :props="defaultProps"
            :default-checked-keys="starId">
          </el-tree>
        </el-form>
      </el-scrollbar>
    </el-dialog>
  </div>
</template>

<script>
  import 'fullcalendar/dist/fullcalendar.css'
  import {
    mapGetters
  } from 'vuex'

  /**
   *@ClassName:homePage
   *@Description:首页
   *@author:李斌
   *@Copyright:格众科技
   *@date:2020-04-17
   */
  export default {
    data() {
      return {
        // 工单
        isQuartzJob: 2, // 工单类型
        state: 2, // 工单状态
        maintainsTableData: [], // 工单列表数据
        maintainsPageTotal1: 0, // 待处理工单数量
        maintainsPageTotal2: 0, // 已完成工单数量
        maintainsPageTotal3: 0, // 总工单数量
        pageCount: 0, // 总页数
        pageNum: 1, // 第几页
        pageSize: 7, // 每页显示数
        state1: 2,
        // 日历
        maintainTypesList: [],
        maintainType: '0',
        commitname: require('@/config/enum').commitname,
        config: {
          firstDay: '0', // 以周日为每周的第一天
          defaultView: 'month', // 默认以月显示
          height: 678,
          fixedWeekCount: false,
          aspectRatio: 1.35, // 设置日历单元格宽度与高度的比例
          handleWindowResize: true, // 是否随浏览器窗口大小变化而自动变化
          eventLimit: true, // 数据条数太多时，限制各自里显示的数据条数（多余的以“+2more”格式显示），默认false不限制,支持输入数字设定固定的显示条数
          eventLimitText: '更多', // 当一块区域内容太多以"+2 more"格式显示时，这个more的名称自定义（应该与eventLimit: true一并用）
          // dayPopoverFormat: 'YYYY年M月d日', // 点开"+2 more"弹出的小窗口标题，与eventLimitClick可以结合用
          allDaySlot: false,
          header: { // 表头信息
            left: 'prev, next, today',
            center: 'title',
            right: 'month, agendaWeek, agendaDay, listMonth'
          },
          locale: 'zh-cn', // 语言
          buttonText: {
            today: '今天',
            month: '月',
            agendaWeek: '周',
            agendaDay: '日',
            listMonth: '日程'
          }
        },
        events: [],
        saveData: '', // 存储数据
        addImage: this.$i18n.t('lang.imgList[0].url'), // 图片
        img: '', // 绑定的图片
        collectList: [], // 收藏所有的内容
        imgList: this.$i18n.t('lang.imgList'), // 收藏夹所有的内容
        title: this.$i18n.t('lang.lab_myCollection'), // 弹框标题
        dialogShow: false, // 弹框显示
        tableData: [], // 展示数据
        starId: [], // 收藏节点的数组
        defaultProps: {
          children: 'children',
          label: 'name'
        }, // 树对象
        photoList: [],
        bannerHeight: 500,
        screenWidth: 1920,
      }
    },
    created() {
      let pageNum = localStorage.getItem('indexPageNum') - 0
      if (pageNum) {
        this.pageNum = pageNum
      } else {
        this.pageNum = 1
      }
      localStorage.removeItem('indexPageNum')
      // 获取table表数据
      this.getTableList()
      this.getCollectData()
      this.maintainTypes()
      this.patrolList()
      this.maintains(2, false)
      this.maintains0()
      this.maintains1()
      this.maintains2()
    },
    computed: {
      ...mapGetters(['gardenId', 'themeColor', 'staffId', 'nickName'])
    },
    watch: {
      // 监听改变小区编号
      gardenId: function (newFlag, oldFlag) {
        this.pageNum = 1
        this.getTableList()
        this.getCollectData()
        this.maintainTypes()
        this.patrolList()
        this.maintains(2, false)
        this.maintains0()
        this.maintains1()
        this.maintains2()
        if (newFlag == 286) {
          this.setSize()
        }
      }
    },
    methods: {
      // 工单start
      // ID序号功能
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      // 隔行变色
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 查询待办list
      maintains(state, isClick) {
        if (isClick) {
          this.pageNum = 1
        }
        this.state1 = state
        let loading = this.$loading()
        this.$get(
          `/maintains?gardenId=0&state=` + state +
          `&isQuartzJob=${this.isQuartzJob}&pageSize=${this.pageSize}&pageNo=${this.pageNum}&staffName=${this.nickName}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              // console.log(res)
              this.maintainsTableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 查询待办list
      maintains0() {
        let loading = this.$loading()
        this.$get(
          `/maintains?gardenId=0&state=2&isQuartzJob=${this.isQuartzJob}&pageSize=${this.pageSize}&pageNo=${this.pageNum}&staffName=${this.nickName}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.maintainsPageTotal1 = res.pageTotal
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 查询完成list
      maintains1() {
        let loading = this.$loading()
        this.$get(
          `/maintains?gardenId=0&state=3&isQuartzJob=${this.isQuartzJob}&pageSize=${this.pageSize}&pageNo=${this.pageNum}&staffName=${this.nickName}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.maintainsPageTotal2 = res.pageTotal
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 查询总list
      maintains2() {
        let loading = this.$loading()
        this.$get(
          `/maintains?gardenId=0&state=99&isQuartzJob=${this.isQuartzJob}&pageSize=${this.pageSize}&pageNo=${this.pageNum}&staffName=${this.nickName}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.maintainsPageTotal3 = res.pageTotal
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },

      // 操作详情
      detail(row) {
        localStorage.setItem('indexPageNum', this.pageNum)
        console.log(row)
        if (row.quartzJobId > 0) {
          this.$router.push({
            name: 'fullprojectAutoInspecRepoBackgroundDetail',
            query: {
              id: row.id
            }
          })
        } else {
          this.$router.push({
            name: 'projectWideRepoInfoBackgroundDetail',
            query: {
              id: row.id
            }
          })
        }
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNum = val
        this.maintains(this.state1, false)
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNum = 1
        this.pageSize = val
        this.maintains(this.state1, false)
      },
      // 详情右键跳转新链接
      jumpNewLink(id) {
        let that = this
        clearInterval(that.timeOut)
        if (this.showingPage === 'fourhundred') {
          const {
            href
          } = this.$router.resolve({
            name: '400backgroundDetail',
            query: {
              id: id
            }
          })
          window.open(href, '_blank')
        } else if (this.showingPage === 'allMaintainQuartzJob') {
          const {
            href
          } = this.$router.resolve({
            name: 'fullprojectAutoInspecRepoBackgroundDetail',
            query: {
              id: id
            }
          })
          window.open(href, '_blank')
        } else if (this.showingPage === 'allMaintain') {
          const {
            href
          } = this.$router.resolve({
            name: 'projectWideRepoInfoBackgroundDetail',
            query: {
              id: id
            }
          })
          window.open(href, '_blank')
        } else if (this.showingPage === 'maintainInfo') {
          const {
            href
          } = this.$router.resolve({
            name: 'repoInfoBackgroundDetail',
            query: {
              id: id
            }
          })
          window.open(href, '_blank')
        }
      },
      // 工单end
      // 日历start
      // 报事类型下拉
      maintainTypes() {
        let loading = this.$loading()
        this.$get(`/maintainTypes`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.maintainTypesList = res.list
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取日历内容
      patrolList() {
        let loading = this.$loading()
        this.$get(`/patrol?gardenId=${this.gardenId}&dutyPersons=${this.staffId}`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.events = res.eventsJsonArray
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      eventRender(event, jsEvent, view) {
        console.log(event)
        console.log(jsEvent)
        console.log(view)
      },
      eventClick(event) {
        console.log(event)
        let route = event.url
        let oneList = route.split('?id=')
        let routeId = oneList[1].split('&')
        console.log(routeId[0])
        let twoList = route.split('&isPatrol=')
        console.log(twoList[1])
        // 跳转到任务管理详情页
        setTimeout(() => {
          this.$router.push({
            name: 'editTask',
            query: {
              flag: true,
              id: routeId[0],
              isPatrol: twoList[1]
            }
          })
        }, 200)
      },
      // 筛选报事分类
      commit() {
        let loading = this.$loading()
        this.$get(`/patrol?gardenId=${this.gardenId}&TypeId1=${this.maintainType}`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.events = res.eventsJsonArray
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 点击天
      dayClick() {
        console.log('点击天')
      },
      // 日历中查看更多
      seeMore() {
        console.log('点击更多')
      },
      // 跳转页面
      jump(path) {
        this.$router.push({
          path: path
        })
      },
      // 日历end
      // 获取收藏夹所有的id
      getImgId() {
        this.collectList = []
        for (let i = 1; i < this.imgList.length; i++) {
          for (let j = 0; j < this.starId.length; j++) {
            if (this.imgList[i].id === this.starId[j]) {
              this.collectList.push(this.imgList[i])
            }
          }
        }
      },
      // 获取table表数据
      getTableList() {
        if (this.gardenId === 0) {
          this.tableData = [...this.$store.getters.userMunuList[1]]
        } else {
          this.tableData = [...this.$store.getters.userMunuList[0]]
        }
      },
      // 获取收藏夹的数据
      getCollectData() {
        let loading = this.$loading()
        this.$get(`/admins/stars?staffId=${this.staffId}`).then(res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.starId = []
              let arr = []
              if (this.gardenId == 0) {
                if (res.star_all && res.star_all.length > 0) {
                  this.starId = res.star_all.split(',')
                  for (let i = 0; i < this.starId.length; i++) {
                    if (arr.indexOf(this.starId[i]) === -1) {
                      arr.push(this.starId[i])
                    }
                  }
                }
              } else {
                if (res.star_one && res.star_one.length > 0) {
                  this.starId = res.star_one.split(',')
                  for (let i = 0; i < this.starId.length; i++) {
                    if (arr.indexOf(this.starId[i]) === -1) {
                      arr.push(this.starId[i])
                    }
                  }
                }
              }
              this.starId = arr
              this.getImgId()
              this.saveData = this.starId.toString()
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },

      // 打开收藏夹按钮
      openCollect() {
        this.getTableList()
        this.getCollectData()
        this.dialogShow = true
      },
      // 监听弹框关闭
      handleDialogClosed() {
        this.starId = this.$refs.tree.getCheckedKeys(true)
        if (this.saveData === this.starId.toString()) {
          this.dialogShow = false
          return false
        }
        let star = []
        for (let index = 0; index < this.starId.length; index++) {
          star.push(this.starId[index].toString())
        }
        this.starId = star
        let loading = this.$loading()
        // 具体小区的场合
        let url = `/admins/star?star_one=${this.starId.toString()}`
        if (this.gardenId == 0) {
          // 全部小区的场合
          url = `/admins/star?star_all=${this.starId.toString()}`
        }
        this.$patch(url).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              if (this.saveData === this.starId.toString()) {
                this.dialogShow = false
              } else {
                this.$message.success(this.$i18n.t('lang.lab_save_success'))
                this.dialogShow = false
              }
              this.getImgId()
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      setSize1: function () {
        var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
        this.screenWidth = width
        // 图片                高 / 宽  500 / 1920
        this.bannerHeight = Math.floor(500 / 1920 * this.screenWidth - 50)
        document.getElementById('el-carousel').style.height = this.bannerHeight + 'px'
      },
      setSize: function () {
        this.bannerHeight = Math.floor(500 / 1920 * this.screenWidth - 50)
        document.getElementById('el-carousel').style.height = this.bannerHeight + 'px'
      },
      showPhoto() {
        this.setSize1()
        const that = this
        // 监听浏览器窗口大小改变
        window.addEventListener('resize', function () {
          var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
          that.screenWidth = width
          that.setSize()
        }, false)
      },
    },
    mounted() {
      this.showPhoto()
    }
  }
</script>

<style lang='scss'>
  .homePage {
    .image {
      display: inline-block;
    }

    .trees .el-checkbox {
      width: 20px;
    }

    .borderin {
      cursor: pointer;
      border: 1px solid #EAEDF1;
      border-radius: 5px;
      background: #ffffff;
      width: 150px;
      height: 200px;
      margin: 10px;
    }

    .borderout {
      cursor: pointer;
      border: 1px solid #EAEDF1;
      border-radius: 5px;
      background: #ffffff;
      width: 150px;
      height: 200px;
      margin: 10px;
      display: inline-block
    }

    .imageadd {
      width: 72px;
      height: 72px;
      margin: auto;
      margin-top: 30px;
      padding-top: 8px;
      position: relative;
      display: block;
    }

    .imageposi {
      width: 80px;
      height: 80px;
      margin: auto;
      margin-top: 30px;
      position: relative;
      display: block;
    }

    .fontposi {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: center;
      margin-top: 30px;
      margin-bottom: 45px;
      font-size: 16px;
      font-weight: Bold;
      color: #464a53;
    }

    .trees {
      height: 500px;
      overflow-y: auto;
    }

    .trees::-webkit-scrollbar {
      width: 10px;
      height: 1px;
    }

    .trees::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background: rgba(144, 147, 153, 0.3);
    }

    .projectCalendarList {
      // flex: 1;
      // width: 900px;
      min-width: 560px;
      overflow: auto;
      margin: 10px;
    }

    .fc-rigid {
      height: 76px !important;
    }

    .fc-day-grid-container {
      height: auto !important;
    }

    .projectBox1 {
      margin-top: 10px;
      padding: 10px 0;
      border: 1px solid #ddd;
      border-radius: 10px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0)
    }

    .projectBox {
      overflow: auto;
      display: flex;
      height: 575px;
      border: 1px solid #ddd;
      border-radius: 10px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0);
    }

    .maintainsNum {
      padding: 10px 0;
      font-size: 20px;
    }

    .maintainsLab {
      margin-left: 20px;
      color: #000;
    }

    .maintainsTxt {
      font-size: 30px;
      font-weight: blod;
      color: red;
    }

    .el-carousel__container {
      height: 100% !important;
    }

    .el-carousel__item .el-image {
      width: 100%;
    }
  }
</style>